import { getBfsTestIds } from "../../../../utils/va-order-test/bestDealSuggestion";
import { getMarkupPrice } from "./markup";
import _ from "lodash";

export function getModifiedDiscountMap(seasonalPromotionList, discountMap, testNodeList) {
  let currentDiscountMap = { ...discountMap };
  addPromosToDiscountMap(currentDiscountMap, seasonalPromotionList);
  let modifiedMap = {};
  Object.keys(currentDiscountMap).forEach(key => {
    let officialBundleIds = currentDiscountMap[key];
    let root = testNodeList.find(node => node.id === Number(key));
    if (root) {
      let testIds = [];
      if (root.id === 60) {
        testIds = [60];
      }
      else {
        getBfsTestIds(root, testIds);
      }
      // find all tests included in current testId
      testIds.forEach(id => {
        let foundItem = modifiedMap[id.toString()];
        if (foundItem) {
          modifiedMap[id.toString()] = foundItem.concat(officialBundleIds);
        }
        else {
          modifiedMap[id.toString()] = officialBundleIds;
        }
      })
    }
  });
  // avoid duplicate discount ids
  Object.keys(modifiedMap).forEach(key => modifiedMap[key] = [...new Set(modifiedMap[key])]);
  return modifiedMap;
}

function addPromosToDiscountMap(discountMap, promos) {
  if (_.isEmpty(discountMap) || promos.length === 0) {
    return;
  }
  promos.forEach(promo => {
    // get all tests in promo's applied bundles
    promo.testIdsInPromo.forEach(testId => {
      let discount = discountMap[testId.toString()];
      if (discount) {
        discountMap[testId.toString()].push(promo.bundleId);
      } else {
        discountMap[testId.toString()] = [promo.bundleId]
      }
    });
  });
}

export function setItemMarkupPriceAndVersion(markupSchemes, testNodeList, bundleList, shortcutList, promotionList) {
  if (!markupSchemes) {
    return;
  }
  let affectedTestNodeIdSet = new Set();
  markupSchemes.forEach(scheme => {
    let affectedItem = null;
    if (scheme.item_type === "bundleId") {
      affectedItem = bundleList.find(b => b.bundleId === Number(scheme.item_id));
    }
    if (scheme.item_type === "packagePriceId") {
      let itemId = scheme.item_id.includes("_") ? scheme.item_id : Number(scheme.item_id);
      let testNode = testNodeList.find(t => t.id === itemId);
      if (testNode) {
        affectedItem = testNode.value;
      }
    }
    if (scheme.item_type === "shortcutId") {
      affectedItem = shortcutList.find(s => s.id === Number(scheme.item_id));
    }
    if (scheme.item_type === "oldPromotionId") {
      affectedItem = promotionList.find(s => s.id === Number(scheme.item_id));
    }
    if (!affectedItem) {
      return;
    }
    let { markup_type, markup_value, version_number, changeable, customized_name } = scheme;
    // type "no_markup" doesn't count as markup items in order page 
    if (markup_type !== "no_markup") {
      affectedItem.markupPrice = getMarkupPrice(markup_type, markup_value, affectedItem.price);
      affectedItem.markupVersion = Number(version_number);
      // add markup test id to affectedTestNodeIdSet (avoid add no_markup parent nodes)
      // calculating its parents' recommendation markup calculation
      if (["va", "vw"].includes(affectedItem.category)) {
        affectedTestNodeIdSet.add(affectedItem.id);
      }
      affectedItem.defaultMarkupPrice = affectedItem.markupPrice;
    } else {
      affectedItem.defaultMarkupPrice = 0;
    }
    affectedItem.changeable = changeable;
    affectedItem.customizedName = customized_name ? customized_name : null;
    affectedItem.orignalCustomizedName = affectedItem.customizedName;
    // add markup price for tests' parents
    addMarkupPriceForParentNodes([...affectedTestNodeIdSet], testNodeList);
  });
}

function addMarkupPriceForParentNodes(affectedTestIdList, testNodeList) {
  let leftOverTestIdSet = new Set([...affectedTestIdList]);
  let remainingTestNodes = testNodeList.filter(node => affectedTestIdList.includes(node.id));
  let deepestLevel = Math.max(...remainingTestNodes.map(node => node.level));
  for (let i = deepestLevel; i > 0; i--) {
    let currentLevelNodes = remainingTestNodes.filter(node => node.level === i);
    currentLevelNodes.forEach(node => {
      if (leftOverTestIdSet.has(node.parent.id)) { // its' parent has its' own markup price, no need update
        return;
      }
      let descendantList = node.parent.descendants;
      // get sum of markup price for each descendants
      let totalMarkupPrice = descendantList.reduce((acc, d) => {
        return acc + (d.value.markupPrice ? d.value.markupPrice : 0)
      }, 0);
      node.parent.value.markupPrice = totalMarkupPrice;
      node.parent.value.markupVersion = -1; // give a -1 markup version for this recommendation price
      // remove all the descendants and add parent back for next loop
      descendantList.forEach(d => {
        leftOverTestIdSet.delete(d.id);
      });
      leftOverTestIdSet.add(node.parent.id);
    });
  }
}